import React from 'react';
import UserImage from '../../assets/images/userimage.png';

const ExecutorRow = (props) => (
  <div className="row mb-3">
    <div className="col-4 text-center">
      <img alt='profile' src={UserImage}/>
    </div>
    <div className="col-8">
      <h4>{props.user_name}</h4>
      <div><i className="fa fa-user"></i>{' '}{props.position_name}</div>
      <div><i className="fa fa-mail-forward"></i>{' '}{ props.received_at }</div>
      {props.sent_at && (
        <div><i className="fa fa-mail-reply"></i>{' '}{ props.sent_at }</div>
      )}
      {props.action_name && (
        <div><i className="fa fa-check-square-o"></i>{' '}{props.action_name}</div>
      )}
      {props.state_name && (
        <div><i className="fa fa-envelope-o"></i>{' '}{props.state_name}</div>
      )}
    </div>
  </div>
)

export default ExecutorRow;


// WEBPACK FOOTER //
// ./src/components/WorkflowProcessHistory/ExecutorRow.js